var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPopupPasswordResetEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3604 53.3201L62.0004 18.6001L106.64 53.3201V107.88H17.3604V53.3201Z",
    fill: "#244469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0004 90.5198L17.3604 53.3198V107.88H106.64V53.3198L62.0004 90.5198Z",
    fill: "#4571B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3604 107.88L47.1204 78.1201L62.0004 90.5201L76.8804 78.1201L106.64 107.88H17.3604Z",
    fill: "#5589D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4566 31.2368L35.163 26.0493L31.7295 65.295L61.9999 90.5204L91.4144 66.0083L94.4566 31.2368Z",
    fill: "#A1B6D6",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7602 28.52H32.2402V65.72L62.0002 90.52L91.7602 65.72V28.52Z",
    fill: "#F8F9FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.1602,
    y: 60.7598,
    width: 39.68,
    height: 1.24,
    rx: 0.619999,
    fill: "#244469"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1201,
    y: 65.7202,
    width: 29.76,
    height: 1.23999,
    rx: 0.619995,
    fill: "#244469"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0876 43.2542C69.0876 43.8062 69.0216 44.3462 68.8896 44.8742C68.7576 45.4022 68.5596 45.8822 68.2956 46.3142C68.0436 46.7462 67.7196 47.0942 67.3236 47.3582C66.9276 47.6102 66.4596 47.7362 65.9196 47.7362C65.4036 47.7362 64.9836 47.5982 64.6596 47.3222C64.3356 47.0342 64.1316 46.6922 64.0476 46.2962H63.9396C63.7116 46.6922 63.3876 47.0342 62.9676 47.3222C62.5596 47.5982 62.0496 47.7362 61.4376 47.7362C60.4776 47.7362 59.7336 47.4302 59.2056 46.8182C58.6896 46.1942 58.4316 45.3722 58.4316 44.3522C58.4316 43.5602 58.5876 42.8582 58.8996 42.2462C59.2236 41.6342 59.6796 41.1542 60.2676 40.8062C60.8676 40.4582 61.5696 40.2842 62.3736 40.2842C62.9136 40.2842 63.4476 40.3322 63.9756 40.4282C64.5156 40.5122 64.9416 40.6142 65.2536 40.7342L65.0736 44.3882C65.0616 44.5802 65.0556 44.7302 65.0556 44.8382C65.0556 44.9342 65.0556 45.0002 65.0556 45.0362C65.0556 45.6242 65.1516 46.0142 65.3436 46.2062C65.5476 46.3862 65.7756 46.4762 66.0276 46.4762C66.3756 46.4762 66.6636 46.3322 66.8916 46.0442C67.1316 45.7442 67.3116 45.3482 67.4316 44.8562C67.5636 44.3642 67.6296 43.8242 67.6296 43.2362C67.6296 42.1562 67.4076 41.2382 66.9636 40.4822C66.5316 39.7262 65.9316 39.1502 65.1636 38.7542C64.4076 38.3582 63.5436 38.1602 62.5716 38.1602C61.2396 38.1602 60.1116 38.4362 59.1876 38.9882C58.2756 39.5402 57.5796 40.2962 57.0996 41.2562C56.6316 42.2162 56.3976 43.3202 56.3976 44.5682C56.3976 46.2962 56.8536 47.6222 57.7656 48.5462C58.6896 49.4702 60.0156 49.9322 61.7436 49.9322C62.4636 49.9322 63.1656 49.8482 63.8496 49.6802C64.5456 49.5242 65.1696 49.3442 65.7216 49.1402V50.5082C65.1936 50.7242 64.5936 50.9042 63.9216 51.0482C63.2616 51.1922 62.5416 51.2642 61.7616 51.2642C60.3216 51.2642 59.0916 51.0002 58.0716 50.4722C57.0516 49.9442 56.2716 49.1882 55.7316 48.2042C55.1916 47.2082 54.9216 46.0142 54.9216 44.6222C54.9216 43.5062 55.0956 42.4742 55.4436 41.5262C55.7916 40.5782 56.2956 39.7562 56.9556 39.0602C57.6276 38.3522 58.4316 37.8062 59.3676 37.4222C60.3156 37.0262 61.3836 36.8282 62.5716 36.8282C63.8316 36.8282 64.9476 37.0862 65.9196 37.6022C66.9036 38.1182 67.6776 38.8562 68.2416 39.8162C68.8056 40.7762 69.0876 41.9222 69.0876 43.2542ZM60.0156 44.3882C60.0156 45.1202 60.1596 45.6542 60.4476 45.9902C60.7476 46.3142 61.1496 46.4762 61.6536 46.4762C62.3016 46.4762 62.7636 46.2362 63.0396 45.7562C63.3276 45.2642 63.4956 44.6342 63.5436 43.8662L63.6516 41.7062C63.4956 41.6702 63.3096 41.6342 63.0936 41.5982C62.8776 41.5622 62.6496 41.5442 62.4096 41.5442C61.8336 41.5442 61.3656 41.6822 61.0056 41.9582C60.6576 42.2342 60.4056 42.5882 60.2496 43.0202C60.0936 43.4522 60.0156 43.9082 60.0156 44.3882Z",
    fill: "#244469"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0001 12.4002V1.24023M94.2401 24.8002L101.68 17.3602M28.5201 24.8002L21.0801 17.3602",
    stroke: "#FFD600",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupPasswordResetEmailIcon);
export default __webpack_public_path__ + "static/media/popup_password_reset_email_icon.a62bcbc9dd265a43b28b2cc0ad639b03.svg";
export { ForwardRef as ReactComponent };